import { CHECK_IN_CODES, CHECKIN_STATUS } from "~/common/utils";
import { RELATED_MODEL } from "~/providers/constants";
import { PatientFeed } from "~/providers/utils/types/interactions";
import { CheckInSubmittedFeed } from "~/providers/utils/types/patientFeeds";
import { FeedCompletedCheckinAnswers } from "./FeedCompletedCheckinAnswers";
import { FeedNote } from "./FeedNote";

interface RenderFeedCardChildrenProps {
  feedOption: PatientFeed;
  internalNote?: string;
  outboundNote?: string;
}
export const RenderFeedCardChildren = ({
  feedOption,
  internalNote,
  outboundNote,
}: RenderFeedCardChildrenProps) => {
  if (
    RELATED_MODEL.patient_checkin === feedOption.related_model_type &&
    feedOption.context.status === CHECKIN_STATUS.completed &&
    feedOption.context.checkin_code !== CHECK_IN_CODES.schedule_appointment
  )
    return (
      <FeedCompletedCheckinAnswers
        answers={(feedOption as CheckInSubmittedFeed).context.data.answers}
        checkInCode={feedOption.context.checkin_code}
      />
    );

  if (outboundNote ?? internalNote) {
    return (
      <div className="flex flex-col gap-2.5 pt-4">
        {[outboundNote, internalNote].map((note, index) => {
          if (!note) return null;
          return (
            <FeedNote
              key={index}
              title={index === 0 ? "Message to patient" : "Internal note"}
              text={note}
            />
          );
        })}
      </div>
    );
  }

  return null;
};
